/**
 * Unified Tracking Initialization
 * Configures both Metrics SDK (type: 'metrics') and Session Recording SDK (type: 'sessionrecord')
 *
 * Usage:
 * 1. Include this file before loading the SDK scripts
 * 2. Load webtracking.js for metrics
 * 3. Load webtracking-session.js for session recording
 */

// =============================================================================
// METRICS TRACKING CONFIGURATION (type: 'metrics')
// =============================================================================
window.WebTrackingConfig = {
  // REQUIRED: Your domain ID
  domainId: 20556,

  // REQUIRED: API endpoint 
  apiEndpoint: 'https://cvm-api.worktual.co.uk/cvm_api_service/v1/insert_tracking_nfspath',

  // Optional: Custom domain name
  domainName: window.location.hostname,

  // Enable/disable features
  autoTrack: true,        // Auto-start tracking
  trackProducts: true,    // Track product clicks
  trackHeatmap: true,     // Track mouse movements & clicks
  trackSession: true,     // Track page sessions

  // Batch interval (milliseconds)
  batchInterval: 60000,   // Send metrics every 10 seconds

  // Debug mode (set to false in production)
  debug: false,
};

// =============================================================================
// SESSION RECORDING CONFIGURATION (type: 'sessionrecord')
// =============================================================================
window.SessionRecordingConfig = {
  // REQUIRED: Your domain ID
  domainId: 20556,

  // REQUIRED: API endpoint
  apiEndpoint: 'https://cvm-api.worktual.co.uk/cvm_api_service/v1/insert_tracking_nfspath',

  // Optional: Custom domain name
  domainName: window.location.hostname,

  // Enable/disable features
  autoStart: true,        // Auto-start recording on page load

  // Recording limits
  maxEvents: 2000,        // Maximum events to store before trimming
  sampleRate: 0.1,        // Mouse movement sampling rate (0.1 = 10%)

  // Batch interval (milliseconds)
  batchInterval: 60000,   // Send session data every 60 seconds

  // Privacy settings
  maskSensitiveData: true,  // Mask emails, credit cards, SSN
  recordPasswords: false,   // Never record password inputs
  recordEmails: false,      // Mask email addresses

  // Debug mode (set to false in production)
  debug: false,
};

// =============================================================================
// GLOBAL TRACKING HELPER FUNCTIONS
// =============================================================================

window.TrackingHelpers = {
  /**
   * Check if user has given consent
   */
  hasConsent: function() {
    const cookie = document.cookie.split('; ').find(row => row.startsWith('CK_Cons='));
    const cookieValue = cookie ? cookie.split('=')[1] : null;
    const localStorageValue = localStorage.getItem('cookieConsent');
    return !!(cookieValue || localStorageValue);
  },

  /**
   * Set user consent
   */
  setConsent: function(accepted) {
    if (accepted) {
      localStorage.setItem('cookieConsent', 'true');
      document.cookie = 'CK_Cons=true; path=/; max-age=31536000; SameSite=Lax';
      console.log('Tracking consent granted. Reloading to initialize tracking...');
      window.location.reload();
    } else {
      localStorage.removeItem('cookieConsent');
      document.cookie = 'CK_Cons=; path=/; max-age=0';
      console.log('Tracking consent denied');
    }
  },

  /**
   * Enable debug mode for both SDKs
   */
  enableDebug: function() {
    if (window.WebTracking) {
      window.WebTrackingConfig.debug = true;
    }
    if (window.SessionRecording) {
      window.SessionRecordingConfig.debug = true;
      window.SessionRecording.configure({ debug: true });
    }
    console.log('Debug mode enabled for all tracking SDKs');
  },

  /**
   * Disable debug mode for both SDKs
   */
  disableDebug: function() {
    if (window.WebTracking) {
      window.WebTrackingConfig.debug = false;
    }
    if (window.SessionRecording) {
      window.SessionRecordingConfig.debug = false;
      window.SessionRecording.configure({ debug: false });
    }
    console.log('Debug mode disabled for all tracking SDKs');
  },

  /**
   * Send all tracking data immediately
   */
  sendAllNow: function() {
    if (window.WebTracking) {
      window.WebTracking.sendNow();
      console.log('Metrics sent');
    }
    if (window.SessionRecording) {
      window.SessionRecording.sendNow();
      console.log('Session recording sent');
    }
  },

  /**
   * Get tracking status
   */
  getStatus: function() {
    const status = {
      consent: this.hasConsent(),
      metrics: {
        loaded: !!window.WebTracking,
        visitorId: window.WebTracking ? window.WebTracking.getVisitorId() : null,
        sessionId: window.WebTracking ? window.WebTracking.getSessionId() : null,
      },
      sessionRecording: {
        loaded: !!window.SessionRecording,
        isRecording: window.SessionRecording ? window.SessionRecording.isRecording() : false,
        visitorId: window.SessionRecording ? window.SessionRecording.getVisitorId() : null,
        sessionId: window.SessionRecording ? window.SessionRecording.getSessionId() : null,
        eventCount: window.SessionRecording ? window.SessionRecording.getSessionData().eventCount : 0,
      },
    };

    console.table(status);
    return status;
  },

  /**
   * Stop all tracking
   */
  stopAll: function() {
    if (window.SessionRecording) {
      window.SessionRecording.stop();
      console.log('Session recording stopped');
    }
    console.log('All tracking stopped');
  },

  /**
   * Start all tracking
   */
  startAll: function() {
    if (window.SessionRecording && !window.SessionRecording.isRecording()) {
      window.SessionRecording.start();
      console.log('Session recording started');
    }
    if (window.WebTracking) {
      console.log('Metrics tracking already running');
    }
  },
};
